<template>
  <div class="d-flex flex-column">
    <subnav :links="subnav" heading="Документы и чек-листы"/>
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
  export default {
    data: () => ({
      subnav: [
        {
          text: 'Документы',
          to: '/admin/documents',
          exact: true,
        },
        {
          text: 'Чек-листы',
          to: '/admin/documents/checklists',
        },
      ],
    }),
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/admin/documents.vue